
<template>
    <div class="container white">
        <div class="row">
          <div class="col-12">
            <FiltrosMeusPendentes @filtroMostrarTipo="handleFiltroMostrarTipo" @filters-applied="handleFilters" @filter-mode-changed="handleFilterModeChanged" />
          </div>
    
          <div class="col-12">
            <div class="card">
              <div class="card-header mb-10">
                <h4 class="mb-0 text-uppercase">Lista de notas pendentes
                </h4>
              </div>
              <div class="card-body">
    
                <div v-if="isLoading" class="text-center my-3">
                  <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
                  <span class="ml-2">Carregando...</span>
                </div>
    
                <TabelaResultadosMeusPendentes key="resultados" v-if="!isLoading" :dados="resultados" :tipo-resultado="tipoResultado" />
    
              </div>
            </div>
          </div>
        </div>
      </div> 
</template>

<script>
import axios from '@/plugins/axios.js';
import FiltrosMeusPendentes from './componentes/FiltrosMeusPendentes.vue';
import TabelaResultadosMeusPendentes from './componentes/TabelaResultadosMeusPendentes.vue';
const ls = require("local-storage")

export default {
  components: {
    FiltrosMeusPendentes,
    TabelaResultadosMeusPendentes
  },
  data() {
    return {
      isLoading: false,
      resultados: [],
      tipoResultado: 'porAno',
      filters: {
        anoLectivo: '',
        curso: '',
        idTipoNota: '',
        tipoNota: '',
        classe: '',
        turma: ''
      }
    };
  },
  watch: {
    tipoResultado(newValue, oldValue) {
      this.resultados = [];
    },

  },
  methods: {
    handleFiltroMostrarTipo(filtro) {
    },

    async handleFilters(recebidos) {
      this.resultados = [];
      this.filters = { ...recebidos };
      this.isLoading = true;
      this.tipoResultado = 'porAno';

      const { anoLectivo, idTipoNota } = recebidos;
      const idInstituicao = ls.get("i_id");
      const idPessoa = ls.get("idPessoa");
      
      try {
        const idProfessor = await this.buscarProfessorPorTurma(idPessoa)
        const { data } = await axios.get(`/verificarNotasPendentesPorProfessor/${anoLectivo}/${idInstituicao}/${idTipoNota}/${idProfessor}`);
        this.resultados = data;
        this.isLoading = false;
      }
      catch (error) {
        this.showMessageSnackbar(`Erro ao carregar dados: ${error.message}`, "error");
      } finally {
        this.isLoading = false;
      }
    },

    async buscarProfessorPorTurma(idPessoa) {
      try {
        const idProfessor = await axios.get(
          `/buscarProfessoresPorIdPessoa/${idPessoa}`
        ).then((res) => res.data[0].idProfessor).catch((err) => console.log(err));
        return idProfessor;
      } catch (error) {
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    handleFilterModeChanged(novoModoTurma) {
      this.tipoResultado = 'porAno';
      this.resultados = [];
      this.filters = {
        anoLectivo: '',
        curso: '',
        idTipoNota: '',
        tipoNota: '',
        classe: '',
        turma: ''
      };
    },

    showMessageSnackbar(mensagem, tipo = 'info') {
      alert(`[${tipo.toUpperCase()}] ${mensagem}`);
    }
  }
};
</script>


<style lang="css" scoped>

</style>